import { render, staticRenderFns } from "./ValuesHeader.vue?vue&type=template&id=86cc9440&scoped=true&"
import script from "./ValuesHeader.vue?vue&type=script&lang=ts&"
export * from "./ValuesHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ValuesHeader.vue?vue&type=style&index=0&id=86cc9440&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86cc9440",
  null
  
)

export default component.exports